<template>
    <div id="banner">
        <div class="text-center">
            <router-link to="/">
                <p>{{ $t('base.seoBanner') }}</p>
            </router-link>
        </div>
    </div>
</template>

<script>
export default {
    name: "SEOBanner"
}
</script>

<style lang="scss" scoped>
    
    a:hover {
        text-decoration: none;
        color: white;
    }
    
    p {
        color: white;
        margin: 0;

        &:hover {
            text-decoration: none;
        }
    }

    #banner {
            width: 100%; 
            background-color: $primary-color;
            padding: 10px;
        }
        
    
</style>